import fetch from 'isomorphic-fetch'
import { IInteractionsModule, IInteractionsConfig, IInteractionsCollectorBody } from './types'

let config: IInteractionsConfig | null = null

const InteractionsModule: IInteractionsModule = {
  configure(interactionsConfig: IInteractionsConfig, aytm_domain: string) {
    config = interactionsConfig
    config.aytm_domain = aytm_domain
    return InteractionsModule
  },

  get enabled() {
    return Boolean(config?.token && config?.url)
  },

  async send(questionID: string, interactionsData: string): Promise<boolean> {
    if (!this.enabled || !config) {
      return false
    }

    const body: IInteractionsCollectorBody = {
      source_host: config.aytm_domain,
      survey_id: config.survey_id,
      completed_survey_id: config.completed_survey_id,
      qref: questionID,
      payload: interactionsData
    }

    try {
      const response = await fetch(config.url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${config.token}`
        },
        body: JSON.stringify(body)
      })
      return response.status === 202
    } catch {
      return false
    }
  }
}

export default InteractionsModule
